import styled from "@emotion/styled"

export const BreadCrumbContainer = styled.div`
  @media (max-width: 768px) {
    padding: 0;
    width: 20%;
    display: none;
  }
`
export const LogoContainer = styled.div`
  width: 112px;
  height: 60px;
  min-width: 112px;
  min-height: 46.08px;

  @media (max-width: 768px) {
    padding: 0;
    mergin-top: 5px;
    justify-content: center;
    display: flex;
  }
`

export const BreadCrumb = styled.p`
  font-weight: 500;
  font-size: 1.125em;
  line-height: 26px;

  @media (max-width: 768px) {
    display: none;
    max-width: 130px;
  }
`

export const TrackLogo = styled.img`
  width: auto;
  object-fit: contain;
  max-width: 112px;
  max-height: 60px;
`

export const ShareButton = styled.div`
  max-width: 180px;
  max-height: 52px;
  min-height: 52px;
  min-width: 161px;

  @media (max-width: 768px) {
    display: none;
    max-width: 170px;
  }
`

export const TrackInfoWrapper = styled.div`
  min-width: 375px;
  max-width: 390px;
  width: 100%;
  margin-inline: auto;
  padding-inline: 0;

  @media (max-width: 768px) {
    width: 100%;
    min-width: 200px;
    overflow: hidden;
    padding-left: 24px;
  }
`

export const EventInfoWrapper = styled.div`
  min-width: 375px;
  max-width: 550px;
  width: 100%;
  margin-inline: auto;

  @media (max-width: 768px) {
    width: 100%;
    min-width: 200px;
    margin-top: -10px;
    padding: 0;
  }
`

export const UserCountWrapper = styled.div`
  justify-content: center;
  max-width: 366px;
  padding-inline: 28px;
  display: flex;
  margin-top: 16px;

  @media (max-width: 768px) {
    margin-inline: auto;
  }
`

export const SeriesCarouselWrapper = styled.div`
  justify-content: center;
  max-width: 366px;
  padding-inline: 28px;
  display: flex;
  margin-top: 16px;
  flex-direction: column;
  margin-inline: auto;
`

export const TrackDetailWrapper = styled.div`
  width: 60%;
  max-width: 750px;
  min-width: 500px;

  @media (max-width: 768px) {
    max-width: 550px;
    margin-inline: auto;
    min-width: 300px;
    width: 100%;
    margin-top: 24px;
    padding-inline: 24px;
  }
`

export const EventScheduleWrapper = styled.div`
  width: 60%;
  padding-left: 30px;
  max-width: 750px;
  min-width: 500px;

  @media (max-width: 768px) {
    max-width: 550px;
    margin-inline: auto;
    min-width: 300px;
    width: 100%;
    margin-top: 24px;
  }
`

export const ScheduleWrapper = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
`
export const ScheduleWrapperMobile = styled.div`
  @media (min-width: 768px) {
    display: none;
  }
`

export const TrackImage = styled.img`
  width: 340px;
  height: 230px;
  min-width: 260px;
  margin-left: 30px;
  opacity: 0.64;
  border-radius: 24px;

  @media (max-width: 768px) {
    overflow: hidden;
    width: 462px;
    min-width: 462px;
    height: 230px;
    margin-left: 30px;
  }
`

export const EventImage = styled.img`
  width: 375px;
  height: 230px;
  min-width: 260px;
  opacity: 0.64;
  border-radius: 20px;

  @media (max-width: 768px) {
    width: 100%;
    height: 240px;
    border-radius: 0px;
  }
`

export const TrackName = styled.p`
  font-weight: 700;
  font-size: 3.5em;
  line-height: 60px;
  text-shadow: 0px 2px 4px rgba(14, 14, 44, 0.1);
  color: #ffffff;
  max-width: 355px;
  margin-top: -105px;
  position: relative;
  z-index: 2;
`

export const EventName = styled.p`
  font-weight: 700;
  font-size: 2.3em;
  line-height: 50px;
  text-shadow: 0px 2px 4px rgba(14, 14, 44, 0.1);
  color: #ffffff;
  margin-top: -85px;
  position: relative;
  z-index: 2;
  padding-inline: 10px;
  max-width: 342px;
`

export const EventLogo = styled.img`
  top: 44px;
  position: relative;
  z-index: 2;

  width: 112px;
  height: 46.08px;
  min-width: 112px;
  min-height: 46.08px;
  object-fit: fill;
`

export const TrackType = styled.p`
  font-weight: 700;
  font-size: 1.5em;
  line-height: 34px;
  color: #ffffff;
  margin-top: 16px;
  z-index: 3;
  position: relative;
`

export const SocialLink = styled.a`
  min-width: 30px;
  min-height: 30px;
  max-width: 55px;
  max-height: 55px;
  padding-inline: 10px;
  margin-inline: 13px;
  display: flex;

  @media (max-width: 768px) {
    padding-inline: 5%;
    max-width: 72px;
    max-height: 72px;
  }
`

export const TrackHeaderWrapper = styled.div`
  margin: 0;
  justify-content: space-between;

  @media (max-width: 768px) {
    margin-inline: auto;
    max-width: 550px;
    display: ${props => (props.isEvent ? "none" : "flex")};
    justify-content: center;
  }
`

export const TrackBodyWrapper = styled.div`
  justify-content: space-evenly;
  margin-top: 45px;

  @media (max-width: 768px) {
    margin-top: 5px;
    flex-direction: column;
    padding: ${props => (props.padding ? props.padding : "")};
  }
`

export const EventBody = styled.div`
  justify-content: space-evenly;

  @media (max-width: 768px) {
    margin-top: 30px;
    flex-direction: column;
    padding: ${props => (props.padding ? props.padding : "")};
  }
`

export const EventBodyContainer = styled.div`
  justify-content: space-evenly;
  margin-top: 40px;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 0;
    margin-top: 0;
    padding-top: -10px;
  }
`

export const PhoneAndMail = styled.div`
  margin-top: 15px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding-bottom: 16px;
  margin-inline: 0px;

  @media (max-width: 768px) {
    margin-right: 24px;
  }
`
export const WebsiteAndSchedule = styled.div`
  justify-content: center;

  @media (max-width: 768px) {
    margin-right: 24px;
  }
`
export const TrackPhone = styled.span`
  margin-left: 10px;
  color: #bbbbbb;
  font-size: 1.5em;
  line-height: 32px;
  font-family: "Roboto";
`

export const TrackAddress = styled.p`
  color: #bbbbbb;
  font-size: 1.5em;
  line-height: 32px;
  font-family: "Roboto";
  font-weight: 500;
`

export const WebLink = styled.a`
  margin-inline: 23px;
  margin: 16px 0;
`

export const TrackWeb = styled.p`
  font-weight: 700;
  color: #bbbbbb;
  font-size: 1em;
  line-height: 20px;
  font-family: "Roboto";
  padding-top: 5px;
`

export const TrackWebWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const WebScheduleImg = styled.img`
  width: 26.6px;
  height: 26.6px;
  vertical-align: middle;
`

export const PromoColContainer = styled.div`
  margin-top: 28px;
  padding-left: 0;

  @media (max-width: 768px) {
    padding-inline: 28px;
  }
`

export const DownloadAppText = styled.p`
  font-size: 2em;
  line-height: 32px;
  font-weight: 700;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  color: #ffffff;
  margin-bottom: 24px;
  padding-bottom: 8px;
  margin-top: 13px;
  max-width: 375;

  @media (max-width: 768px) {
    margin-top: 3px;
    margin-bottom: 16px;
    margin-right: 0px;
    text-align: center;
  }
`

export const PitpayDownloadText = styled.p`
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 1.125em;
  line-height: 24px;
  color: #888888;
`

export const DownloadText = styled.p`
  font-size: 2em;
  line-height: 40px;
  font-weight: 700;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  color: #ffffff;
  margin-bottom: 8px;
  padding-bottom: 8px;

  @media (max-width: 768px) {
    font-size: 1.75em;
    margin-bottom: 16px;
    line-height: 32px;
  }
`

export const SeeMoreEvents = styled.p`
  font-size: 1.4em;
  font-weight: 700;
  text-align: center;
  color: #ffffff;
  margin: 55px 0px;
  cursor: pointer;

  @media (max-width: 768px) {
    display: none;
  }
`

export const SeeMoreEventsButton = styled.div`
  padding-top: 20px;
  @media (min-width: 768px) {
    display: none;
  }
`

export const DownloadButtons = styled.div`
  font-size: 2em;
  line-height: 40px;
  font-weight: 700;
  color: #ffffff;
  display: flex;
  flex-direction: row;
  margin-top: 16px;
  min-height: 64px;
  justify-content: start;
  padding-left: 17px;
  background-color: #fa4616;
  padding: 12px 12px 12px 17px;
  border-radius: 8px;
  margin-right: 16px;
  min-width: 375px;
  width: 375px;
  cursor: pointer;

  @media (max-width: 768px) {
    min-width: ${props => props.minWidth};
  }
`

export const TicketText = styled.p`
  font-weight: 700;
  font-size: 1.5em;
  line-height: 34px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #ffffff;
  opacity: 0.8;
  margin-top: 24px;
  max-width: 375px;

  @media (max-width: 768px) {
    display: none;
  }
`

export const TicketTextMobile = styled.p`
  font-weight: 700;
  font-size: 1.5em;
  line-height: 34px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #ffffff;
  opacity: 0.8;
  margin-top: 10px;
  max-width: 327px;

  @media (min-width: 768px) {
    display: none;
  }
`

export const VideoPlayer = styled.iframe`
  width: 100%;
  min-width: 450px;
  height: 428px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding-bottom: 32px;

  @media (max-width: 768px) {
    display: none;
  }
`

export const VideoPlayerMini = styled.iframe`
  min-width: 230px;
  width: 100%;
  height: 212px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding-bottom: 32px;

  @media (min-width: 768px) {
    min-width: 130px;
    display: none;
    margin-right: 5px;
  }
`

export const ShareIcon = styled.img`
  max-width: 69px;
  max-height: 69px;
  @media (min-width: 768px) {
    display: none;
  }
`

export const PurchaseContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: row;
    overflow-x: scroll;
    white-space: nowrap;
    padding-inline: 0px;

    ::-webkit-scrollbar {
      display: none;
    }
  }
`

export const PurchaseButton = styled.div`
  @media (max-width: 768px) {
    margin-right: 16px;
    min-width: 314px;
    max-width: 500px;
  }
`

export const EventDetailWrapper = styled.div`
  width: 70%;
  padding-left: 26px;
  max-width: 800px;
  min-width: 700px;
  margin-inline: auto;

  @media (max-width: 768px) {
    min-width: 300px;
    max-width: 550px;
    margin-inline: auto;
    width: 100%;
  }
`

export const EventFilterWrapper = styled.div`
  min-width: 250px;
  max-width: 400px;

  @media (max-width: 768px) {
    display: none;
  }
`

export const EventBodyWrapper = styled.div`
  width: 100%;
  justify-content: start;
`

export const HaveQuestion = styled.p`
  font-weight: 700;
  font-size: 1.75em;
  line-height: 32px;
  display: flex;
  align-items: center;
  color: #ffffff;
  margin-top: 20px;
`

export const ContactList = styled.span`
  font-weight: 500;
  font-size: 1.5em;
  line-height: 32px;
  display: flex;
  align-items: center;
  color: #bbbbbb;
  opacity: 0.8;
  word-break: break-all;
`

export const InfoIcon = styled.img`
  width: 24px;
  height: 24px;
  vertical-align: middle;
  margin-top: 5px;
  margin-right: 10px;
`
export const TicketsImage = styled.img`
  cursor: pointer;
  width: 100%;
  max-width: 366px;
  min-width: 366px;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;

  @media (max-width: 768px) {
    object-fit: cover;
    min-width: 336px;
    max-width: 100%;
    justify-content: center;
    display: flex;
    margin-inline: auto;
  }
`

export const PitpayTicketsImage = styled.img`
  cursor: pointer;
  width: 100%;
  max-width: 366px;
  min-width: 366px;
  height: 64px;
  object-fit: cover;
  border-radius: 8px;
  margin-top: 14px;

  @media (max-width: 768px) {
    object-fit: cover;
    min-width: 336px;
    max-width: 100%;
    justify-content: center;
    display: flex;
    margin-inline: auto;
  }
`
export const PitpayAnnualImage = styled.img`
  width: 40px;
  height: 40px;
  object-fit: contain;
`
export const PitpayAnnualTicketsImage = styled.div`
  cursor: pointer;
  width: 100%;
  max-width: 363px;
  min-width: 363px;
  min-height: 64px;
  border-radius: 8px;
  margin-top: 14px;
  background-color: #fff;
  padding: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  vertical-align: middle;
  align-items: center;

  @media (max-width: 768px) {
    min-width: 336px;
    max-width: 100%;
    justify-content: space-between;
    display: flex;
    margin-inline: auto;
  }
`
export const PitpayAnnualTicketText = styled.span`
  font-size: 2em;
  line-height: 32px;
  font-weight: 700;
  color: #000033;
`

export const PitpayAnnualTicketTextContainer = styled.div`
  align-items: center;
  display: flex;
  gap: 10px;
`

export const ArrowRight = styled.img`
  vertical-align: middle;
  width: 20px;
  height: 20px;
  margin-right: 10px;
`

export const PromoContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  margin-top: 16px;
  width: 100%;
  max-width: 366px;

  @media (max-width: 768px) {
    justify-content: center;
    display: flex;
    margin-inline: auto;
  }
`

export const DownloadContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  margin-top: 16px;
  width: 100%;
  max-width: 366px;

  @media (max-width: 768px) {
    justify-content: center;
    display: flex;
    margin-inline: auto;
  }
`

export const PromoImages = styled.img`
  flex: 1;
  max-width: ${props => (props.isFull ? "366px" : "175px")};
  height: ${props => (props.isFull ? "64px" : "140px")};
  cursor: pointer;
  object-fit: cover;

  @media (max-width: 768px) {
    width: 48%;
    max-width: ${props => (props.isFull ? "100%" : "156px")};
    border-radius: 8px;
  }
`

export const InterestedWrapper = styled.p`
  font-weight: 700;
  font-size: 1em;
  line-height: 20px;
  text-align: center;
  color: #fff;
  min-width: 160px;
  height: 40px;
  padding: 8px;
  margin-top: 0px;
`
export const Divider = styled.div`
  height: 20px;
  background-color: #fff;
  width: 1px;
  margin-top: 10px;
  padding-left: 1px;
`

export const SocialLinkWrapper = styled.div`
  justify-content: center;
  margin-top: 11px;
  margin-left: -12px;
`

export const FaqQuestion = styled.p`
  color: #fff;
  font-size: 1.5em;
  line-height: 32px;
  font-weight: 700;
  margin-bottom: 5px;
`

export const FaqAnswer = styled.p`
  font-size: 1.1em;
  line-height: 24px;
  margin-bottom: 8px;
  font-family: "Roboto";
  font-weight: 500;
`

export const NoEventWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10%;
  text-align: center;
  font-size: 1.5em;
  line-height: 32px;
  font-weight: 700;
`

export const DetailStyle = styled.div`
  a {
    font-family: "Roboto";
  }
`
